import styled from '@emotion/styled';
import DecorateTitle from 'components/DecorateTitle';
import { useMemo } from 'react';
import {
  getResultContexts,
  ResultText,
} from 'views/Aide/Scenario/PolicyForm/BilingualExecuteContextField';
import ExecuteContextsFieldV2, {
  ExecuteContextsFieldV2Props,
} from 'views/Aide/Scenario/PolicyForm/ExecuteContextsFieldV2';
import { ScenarioResult, ScenarioResultProps } from 'views/Setting/AutoEmit/components/Result';
import EditorPreviewer from 'components/EditorPreviewer';
import useMustacheSticker2Url from 'hooks/business/useMustacheSticker2Url';
import { useTranslate } from '@tolgee/react';

const Container = styled.div`
  display: flex;
  flex-direction: row;
  padding: 25px;
  background: #fff;
  border-radius: 4px;
`;
const LeftContainer = styled.div`
  flex: 2;
`;
const RightContainer = styled.div`
  flex: 1;
  margin-left: 22px;
  padding-left: 32px;
  border-left: 1px solid #f0f2f5;
`;
const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
const DemoTitle = styled.h4`
  color: #232426;
`;

export interface RegionMsgContentEditorProps extends ExecuteContextsFieldV2Props {
  title: string;
  titleExtra?: React.ReactNode;
  disabled?: boolean;
}

export const RegionMsgContentEditor = (props: RegionMsgContentEditorProps) => {
  const { value, title, platform, region, titleExtra } = props;

  const [getStickerUrl] = useMustacheSticker2Url(platform, region);
  const { t } = useTranslate();

  const demoResult = useMemo(() => {
    if (!value) {
      return [];
    }
    return [value].reduce<ScenarioResultProps['list']>((res, executeContext) => {
      const resultContext = getResultContexts(executeContext, true);

      res.push(
        ...(resultContext
          ? resultContext.map((context) => {
              return {
                type: 'reply',
                content: (
                  <ResultText>
                    <EditorPreviewer getStickerUrl={getStickerUrl} value={context} />
                  </ResultText>
                ),
              } as const;
            })
          : [
              {
                type: 'reply',
                content: '',
              } as const,
            ]),
      );

      return res;
    }, []);
  }, [getStickerUrl, value]);

  return (
    <Container>
      <LeftContainer>
        <Header>
          <DecorateTitle>{title}</DecorateTitle>
          {titleExtra}
        </Header>
        <ExecuteContextsFieldV2
          isReply
          supportTranslate
          {...props}
          platform={platform}
          value={value}
        />
      </LeftContainer>
      <RightContainer>
        <DemoTitle>{t('marketing.示例')}</DemoTitle>
        <ScenarioResult list={demoResult} />
      </RightContainer>
    </Container>
  );
};
